import { render } from "./CardInfo.vue?vue&type=template&id=7dff8b2f"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__